'use client';

import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';

export function FundingStatusHeader({
  artwork,
  title,
  description,
}: {
  artwork:
    | 'quote-expired'
    | 'method-expired'
    | 'offline'
    | 'kyc-pending'
    | 'kyc-rejected'
    | 'kyc-success';
  title: string;
  description: string;
}): ReactNode {
  return (
    <div className="flex items-center gap-4 pt-2">
      <OptimizedImage
        // ALLOW-NSFW-FALSE: approved bundled status artwork from the onramp mockup.
        nsfw={false}
        variant="thumbnail"
        // ALLOW-NO-PREVIEW: Decorative bundled artwork has no expanded media view.
        preview={false}
        loadReveal="none"
        rounded=""
        imageClassName="object-contain"
        src={`/assets/onramp/status-${artwork}.png`}
        alt=""
        size="size-18"
        className="shrink-0 bg-transparent"
      />
      <div>
        <h3 className="text-lg font-semibold leading-6">{title}</h3>
        <p className="mt-1.5 text-caption leading-4.5">{description}</p>
      </div>
    </div>
  );
}
